import request from "@/api/request";

class GenerateUrl {
  getParams(token) {
    return request({
      url: "/api/secureurl/" + token,
      method: "get"
    });
  }
  getList(customer) {
    return request({
      url: "/api/secureurl/list/" + customer,
      method: "get"
    });
  }

  postParams(data) {
    return request({
      url: "/api/secureurl/add",
      method: "post",
      data: data
    });
  }
  postDelete(data) {
    return request({
      url: "/api/secureurl/delete",
      method: "post",
      data: data
    });
  }
}

export default new GenerateUrl();
